import { container } from '../../../DataDomain';
import { IBundleAndSaveRulesParams, IBundleAndSaveRulesResponse } from '../../../entity';
import { ISlpRepository } from '../../repositories/interfaces/iSlpRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IBundleAndSaveRulesUseCase {
    execute(payload: IBundleAndSaveRulesParams, identityToken?: string): Promise<IBundleAndSaveRulesResponse>;
}

export class BundleAndSaveRulesUseCase implements IBundleAndSaveRulesUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get slpRepo(): ISlpRepository {
        return container.resolve<ISlpRepository>(DI.REPOSITORIES.ISlpRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(payload: IBundleAndSaveRulesParams, identityToken?: string): Promise<IBundleAndSaveRulesResponse> {
        return await this.slpRepo.bundleAndSaveRules(payload, identityToken);
    }
}
